export enum AdvisoriesLookupStatus {
  DOES_NOT_EXIST = 1,
  SUCCESS,
  SYSTEM_FAILURE,
  TIMEOUT,
  LOADING,
  UNKNOWN,
}
